module.exports = __webpack_public_path__ + "static/quartier_C-b6d7f21d20e48dd6a413f39bf65eb133.png";